import { routes } from "@/constants/routes";
import { Redirect } from "expo-router";

/** Der Pflegekatalog unter der Mandanten-Konfiguration gibt es nicht mehr. */
export default function ConfigMedicationRedirect() {
  return <Redirect href={routes.home} />;
}
